import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const DevelopmentSection = ({ development, onChange }) => (
  <section>
    <div className="section-header flex items-center gap-2 py-1.5 px-3">
      <span className="text-sm">📋</span>
      <span className="text-sm">Personal & Professional Development</span>
    </div>
    <div className="p-3 space-y-2">
      <div className="grid grid-cols-3 gap-3">
        <div>
          <Label className="text-xs font-medium text-muted-foreground">Personal</Label>
          <Textarea
            value={development.personal}
            onChange={(e) => onChange('personal', e.target.value)}
            placeholder="Personal goals..."
            className="mt-0.5 tactical-input text-sm min-h-[60px]"
            data-testid="development-personal"
          />
        </div>
        <div>
          <Label className="text-xs font-medium text-muted-foreground">Professional</Label>
          <Textarea
            value={development.professional}
            onChange={(e) => onChange('professional', e.target.value)}
            placeholder="Professional goals..."
            className="mt-0.5 tactical-input text-sm min-h-[60px]"
            data-testid="development-professional"
          />
        </div>
        <div>
          <Label className="text-xs font-medium text-muted-foreground">Soft Skills</Label>
          <Textarea
            value={development.soft_skills}
            onChange={(e) => onChange('soft_skills', e.target.value)}
            placeholder="Soft skills goals..."
            className="mt-0.5 tactical-input text-sm min-h-[60px]"
            data-testid="development-soft-skills"
          />
        </div>
      </div>
    </div>
  </section>
);
